import { useNavigate } from "react-router";
import { useEffect } from "react";
import { APP_ROUTES } from "../constants/appRoutes";
import SessionStorageUtility from "./utilities/SessionStorageUtility";

const ClearDeviceIdComponent = () => {
    const navigate = useNavigate()
    SessionStorageUtility.removeStoredUnmappedDeviceId()
    
    useEffect(() => {
        navigate(APP_ROUTES.ROOT)
    })
    return (<></>)
};

export default ClearDeviceIdComponent;
